import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Oman = () => {
    return <SharedDocumentsComponent permissionId="45" path="Omã" />
}